import React, { AllHTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
// import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Modal } from "antd";
interface C2CModalProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
  visible?: boolean;
  changeVisible?(): void;
  changeVerify?(): void;
}
const { useTranslation } = Hooks;
const C2CModal: React.FC<C2CModalProps> = ({ className, visible = false, changeVisible, changeVerify }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <Modal className={styles["ant-Modal"]} open={visible} title="" width={400} footer={null} centered closable={false}>
      <div>
        <div className={styles["fa_tip"]}>{t("account.prompt")}</div>
        <div className={styles["fa_text"]}>{t("2fa.tip")}</div>
        <div className={styles["fa_opera"]}>
          <div onClick={changeVisible} className={styles["fa_cancel"]}>
            {t("account.cancel")}
          </div>
          <div onClick={changeVerify} className={styles["fa_sure"]}>
            {t("account.Confirm")}
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default observer(C2CModal);
